<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem :label="$tt('选择时间')" :label-width='70'>
				<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
			</FormItem>
			<!-- <FormItem :label="$tt('结束时间')" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeEnd"></DatePicker>
			</FormItem> -->
			<!-- <FormItem >
				<Input type="text" v-model="formInline.MemberName" :placeholder="$tt('会员名称')">
				<span slot="prepend">{{$tt('会员名称')}}</span>
				</Input>
			</FormItem> -->
			<FormItem>
				<Input type="text" style="width: 180px;" v-model="formInline.PhoneNo" :placeholder="$tt('会员手机')">
				<span slot="prepend">{{$tt('会员手机')}}</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{$tt('查询')}}</Button>
			</FormItem>
			<!-- <div>{{formInline.TimeBegin}} - {{formInline.TimeEnd}}: {{formInline.TimeRange}}</div> -->
		</Form>
		<Card class="card" style="margin-bottom: 20px;">
			<!-- <template #title>{{$tt('会员信息')}}</template> -->
			<Row :gutter="20" class="summy">
				<Col span="12" class="text">{{$tt('会员总人数(人)：')}}<span class="value">{{memberStatisticsInfo.MemberNum}}</span></Col>
				<Col span="12" class="text">{{$tt('总账户余额(元)：')}}<span class="value">{{memberStatisticsInfo.MemberBalance.toFixed(2)}}</span></Col>
			</Row>
		</Card>
		<Row :gutter="20">
			<Col span="12">
			<Card class="card">
				<template #title>{{$tt('即时')}}</template>
				<div><span class="text">{{$tt('即时支付金额(元)：')}}</span><span
						class="value">{{memberStatisticsInfo.PrepayRecharge.toFixed(2)}}</span></div>
				<div><span class="text">{{$tt('即时消费金额(元)：')}}</span><span
						class="value">{{memberStatisticsInfo.PrepayConsume.toFixed(2)}}</span></div>
				<div><span class="text">{{$tt('即时退款金额(元)：')}}</span><span
						class="value">{{memberStatisticsInfo.PrepayRefund.toFixed(2)}}</span></div>
				<div><span class="text">{{$tt('即时冻结金额(元)：')}}</span><span
						class="value">{{memberStatisticsInfo.PrepayFreeze.toFixed(2)}}</span></div>
			</Card>
			</Col>
			<Col span="12">
			<Card class="card">
				<template #title>{{$tt('钱包')}}</template>
				<div><span class="text">{{$tt('钱包支付金额(元)：')}}</span><span
						class="value">{{memberStatisticsInfo.WalletRecharge.toFixed(2)}}</span></div>
				<div><span class="text">{{$tt('钱包消费金额(元)：')}}</span><span
						class="value">{{memberStatisticsInfo.WalletConsume.toFixed(2)}}</span></div>
				<div><span class="text">{{$tt('钱包退款金额(元)：')}}</span><span
						class="value">{{memberStatisticsInfo.WalletRefund.toFixed(2)}}</span></div>
				<div><span class="text">{{$tt('钱包冻结金额(元)：')}}</span><span
						class="value">{{memberStatisticsInfo.WalletFreeze.toFixed(2)}}</span></div>
			</Card>
			</Col>
		</Row>
	</div>
</template>

<script>
	import webapi from '../../../webapi.js';
	export default {
		data() {
			return {
				memberStatisticsInfo: {
					MemberNum: 0,
					MemberBalance: 0,
					PrepayRecharge: 0,
					PrepayConsume: 0,
					PrepayRefund: 0,
					PrepayFreeze: 0,
					WalletRecharge: 0,
					WalletConsume: 0,
					WalletRefund: 0,
					WalletFreeze: 0,
				},
				BreadcrumbList: [this.$tt('个人会员'), '>>', this.$tt('会员统计')],
				formInline: {
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
					TimeEnd: new Date(),
					TimeBegin: new Date(new Date().getTime() - 1000 * 60 * 60 * 24)
				}
			}
		},
		mounted() {
			this.handleSubmit();
		},
		methods: {
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Member/GetMemberStatisticsInfo ", _this.formInline, {}).then(
					res => {
						if (res.data.Code == 0) {
							_this.$Message.success(this.$tt('请求成功'));
							_this.memberStatisticsInfo = res.data.Data;
						} else {
							_this.$Message.error(this.$tt('请求失败'));
						}
					}).catch(err => {
						_this.$Message.error(this.$tt('请求失败'));
				});
			},
			hasWidgets(widget) {
				return true;
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			}
		}
	}
</script>

<style scoped>
	#app {
		text-align: left;
	}
	
	.ivu-card-head::before {
		content: '⊱⊱ ';
		color: lightskyblue;
	}
	.ivu-card-head::after {
		content: ' ⊰⊰';
		color: lightskyblue;
	}

	.summy .text,
	.card .text {
		font-size: 20px;
	}

	.card .value {
		font-size: 24px;
		color: royalblue;
	}
</style>
